/**
 * The long explanation, folded away until somebody wants it.
 *
 * This console explains itself unusually well and had nowhere to put the explanation. Every screen in
 * the fleet area carried its reasoning as standing prose - a paragraph under the title, a muted lead
 * under each card heading, a closing hint under each table - so the Devices tab ran to eleven thousand
 * pixels and the device list started two thirds of the way down it. The words were not the problem;
 * all of them are worth reading once. Being unable to get past them was.
 *
 * So the rule this encodes is a split, not a deletion. **A warning somebody decides against acting on
 * stays on the page; an explanation somebody reads once goes in here.** Trust's rotation warning is
 * the canonical case of the first and is deliberately untouched: a warning only seen after asking is a
 * warning too late (D-423). Nothing that has ever been the reason not to press a button is folded.
 *
 * A disclosure rather than a tooltip, which `styles.css` had already decided for the exposure formula
 * and says why: the working has to be readable, and a tooltip is not. It is also the only form of this
 * that works on a phone and from a keyboard without anything being written to make it (D-432).
 */
export function Explainer({
  summary,
  children,
  'data-testid': testId
}: {
  /** What the reader gets by opening it. A question they would actually ask, not "More information". */
  summary: string
  children: React.ReactNode
  'data-testid'?: string
}) {
  return (
    <details className="card explainer" data-testid={testId}>
      <summary className="card-body">{summary}</summary>
      <div className="card-body">{children}</div>
    </details>
  )
}
